import { isEmpty } from 'src/utils/isEmpty'

/**
 * @description when soonest available practitioner is selected
 * or practitionerId is empty - should return undefined
 * @param pracitionerReferenceId id of selected practitioner
 * @return practitionerId or undefined
 */
export const getPractitionerReferenceIds = (pracitionerReferenceIds?: string[]): string[] | undefined => {
  return isEmpty(pracitionerReferenceIds) ? undefined : pracitionerReferenceIds
}
